"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Footer = void 0;
var _react = require("react");
var _hooks = require("../../../hooks");
var _CetComponentsProvider = require("../../../providers/CetComponentsProvider");
var _A = require("../../../UI/A");
var _facebook = _interopRequireDefault(require("./resources/facebook.svg"));
var _linkedin = _interopRequireDefault(require("./resources/linkedin.svg"));
var _youtube = _interopRequireDefault(require("./resources/youtube.svg"));
var _CET_logo_he = _interopRequireDefault(require("./resources/CET_logo_he.svg"));
var _CET_logo_ar = _interopRequireDefault(require("./resources/CET_logo_ar.svg"));
var _CET_logo_en = _interopRequireDefault(require("./resources/CET_logo_en.svg"));
var _LogoOfek_he = _interopRequireDefault(require("./resources/LogoOfek_he.svg"));
var _LogoOfek_ar = _interopRequireDefault(require("./resources/LogoOfek_ar.svg"));
var _LogoOfek_en = _interopRequireDefault(require("./resources/LogoOfek_en.svg"));
var _Footer = require("./Footer.labels");
var _Footer2 = _interopRequireDefault(require("./Footer.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Footer = function Footer(props) {
  var termsOfUseUrl = props.termsOfUseUrl,
    systemRequirementsUrl = props.systemRequirementsUrl,
    accessabilityTermsUrl = props.accessabilityTermsUrl,
    aboutUrl = props.aboutUrl,
    purchaseUrl = props.purchaseUrl,
    helpUrl = props.helpUrl,
    siteLogoUrl = props.siteLogoUrl,
    _props$withSidebarMar = props.withSidebarMargin,
    withSidebarMargin = _props$withSidebarMar === void 0 ? false : _props$withSidebarMar;
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    language = _useContext.language;
  var getLabel = (0, _hooks.useLabels)({
    labels: _Footer.labels
  });
  var styles = (0, _Footer2.default)(isMobileView, withSidebarMargin);
  var cetLogo = {
    he: _CET_logo_he.default,
    ar: _CET_logo_ar.default,
    en: _CET_logo_en.default
  };
  var siteLogo = {
    he: _LogoOfek_he.default,
    ar: _LogoOfek_ar.default,
    en: _LogoOfek_en.default
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("footer", {
    className: styles['cc-Footer'],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: styles['cc-Footer__logo'],
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: cetLogo[language],
        alt: getLabel('cet')
      }), isMobileView ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: styles['cc-Footer__vertical-line']
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: siteLogoUrl || siteLogo[language],
          alt: getLabel('cet')
        })]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: styles['cc-Footer__rights'],
        children: ["\xA9 ", getLabel('copy_rights')]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: styles['cc-Footer__links'],
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_A.A, {
        target: "_blank",
        to: termsOfUseUrl || getLabel('term_of_use_link'),
        customStyle: styles['cc-Footer__link'],
        children: getLabel('term_of_use')
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_A.A, {
        target: "_blank",
        to: systemRequirementsUrl || getLabel('system_requirements_link'),
        customStyle: styles['cc-Footer__link'],
        children: getLabel('system_requirements')
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_A.A, {
        target: "_blank",
        to: accessabilityTermsUrl || getLabel('accessability_terms_link'),
        customStyle: styles['cc-Footer__link'],
        children: getLabel('accessability_terms')
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: styles['cc-Footer__links'],
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_A.A, {
        target: "_blank",
        to: aboutUrl || getLabel('about_link'),
        customStyle: styles['cc-Footer__link'],
        children: getLabel('about')
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_A.A, {
        target: "_blank",
        to: purchaseUrl || getLabel('purchase_link'),
        customStyle: styles['cc-Footer__link'],
        children: getLabel('purchase')
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_A.A, {
        target: "_blank",
        to: helpUrl || getLabel('help_link'),
        customStyle: styles['cc-Footer__link'],
        children: getLabel('help')
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: styles['cc-Footer__info'],
      children: [isMobileView ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-Footer__horizontal-line']
      }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        children: [getLabel('contact_us'), ":"]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: styles['cc-Footer__address'],
        children: [getLabel('address_street'), /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), getLabel('address_city')]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_A.A, {
          target: "_blank",
          to: "mailto:".concat(getLabel('contact_email')),
          customStyle: styles['cc-Footer__contact-link'],
          children: getLabel('contact_email')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: styles['cc-Footer__contact-link-separator'],
          children: "|"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_A.A, {
          target: "_blank",
          to: "tel:".concat(getLabel('contact_phone')),
          customStyle: styles['cc-Footer__contact-link'],
          children: getLabel('contact_phone')
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: styles['cc-Footer__socials'],
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_A.A, {
        target: "_blank",
        to: getLabel('facebook_link'),
        isBtnView: true,
        view: "contained",
        color: "basic",
        shape: "round",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: _facebook.default,
          alt: getLabel('facebook')
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_A.A, {
        target: "_blank",
        to: getLabel('linkedin_link'),
        isBtnView: true,
        view: "contained",
        color: "basic",
        shape: "round",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: _linkedin.default,
          alt: getLabel('linkedin')
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_A.A, {
        target: "_blank",
        to: getLabel('youtube_link'),
        isBtnView: true,
        view: "contained",
        color: "basic",
        shape: "round",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: _youtube.default,
          alt: getLabel('youtube')
        })
      })]
    })]
  });
};
exports.Footer = Footer;